import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, PieChart, Clock } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: PieChart,
    title: '1) El Triángulo Cash Real™',
    description: "Separar tu compra en 3 baldes: dinero para oferta/EMD, dinero para inspección/trámites, y dinero final (cash to close). Cuando lo separas, dejas de sentir que 'todo te está saliendo del mismo bolsillo a la vez'."
  }, {
    icon: ShieldCheck,
    title: '2) El Buffer de Variación',
    description: "Un método para crear un rango seguro hasta que taxes, seguro, HOA y fechas estén confirmados. No para 'asustarte'. Para que no te agarre de sorpresa."
  }, {
    icon: Clock,
    title: '3) El Protocolo 7‑3‑1',
    description: 'Qué pedir, a quién, y cuándo: 7 días antes (anclar lo grande), 3 días antes (comparar LE vs CD), 24 horas antes (cerrar monto + instrucciones). Es pasar de esperar a liderar.'
  }];
  return <section className="py-24 bg-navy-900 text-cream-50 relative overflow-hidden" data-id="element-208">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-209">
        <div className="absolute top-1/4 left-0 w-64 h-64 bg-gold-500/10 rounded-full blur-3xl" data-id="element-210" />
        <div className="absolute bottom-1/4 right-0 w-96 h-96 bg-navy-800/50 rounded-full blur-3xl" data-id="element-211" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <span className="text-gold-400 font-medium tracking-wider uppercase text-sm" data-id="element-214">
            Presentando
          </span>
          <h2 className="text-3xl md:text-5xl font-bold mt-2 mb-6 text-cream-50" data-id="element-215">
            Cash‑to‑Close{' '}
            <span className="text-gold-400 italic" data-id="element-216">Sin Ansiedad</span> (USA)
          </h2>
          <p className="text-xl text-cream-200/80 max-w-2xl mx-auto" data-id="element-217">
            Un sistema que convierte tus documentos en decisiones simples.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-218">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.2
        }} className="bg-navy-800/50 backdrop-blur-sm border border-navy-700 p-8 rounded-2xl hover:border-gold-500/30 transition-colors duration-300" data-id="element-219">
              <div className="w-14 h-14 bg-navy-900 rounded-xl flex items-center justify-center mb-6 border border-gold-500/20 shadow-lg shadow-gold-500/5" data-id="element-220">
                <feature.icon className="w-7 h-7 text-gold-400" data-id="element-221" />
              </div>
              <h3 className="text-xl font-bold text-cream-50 mb-4" data-id="element-222">
                {feature.title}
              </h3>
              <p className="text-cream-200/70 leading-relaxed" data-id="element-223">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}